// The rename (Denwen MSP, formerly FlowMSP): browser storage keys were flowmsp.* (and fmsp.tenant).
// On first load after the rename, each old key moves to its new name, unless the new one is already
// set, so the theme, the running timer, the HMRC device id and the rest survive. Storage belongs to
// one origin: this helps on the same address, not across the move to a new host. Imported first by
// main.tsx, before any module reads storage. Remove after one release cycle.

/** Old key -> new key, per storage area. */
export const LEGACY_STORAGE_KEYS = {
  local: {
    'flowmsp.theme': 'denwen-msp.theme',
    'flowmsp.sidebar.collapsed': 'denwen-msp.sidebar.collapsed',
    'flowmsp.hmrc.deviceId': 'denwen-msp.hmrc.deviceId',
    'flowmsp.projects.view': 'denwen-msp.projects.view',
    'flowmsp.schedule.technicians': 'denwen-msp.schedule.technicians',
    'flowmsp.timer.v1': 'denwen-msp.timer.v1',
    'fmsp.tenant': 'dmsp.tenant',
  },
  session: {
    'flowmsp.portal.returnTo': 'denwen-msp.portal.returnTo',
    'flowmsp.signup.progress': 'denwen-msp.signup.progress',
  },
} as const;

function move(storage: Storage, keys: Record<string, string>) {
  for (const [oldKey, newKey] of Object.entries(keys)) {
    const value = storage.getItem(oldKey);
    if (value === null) continue;
    if (storage.getItem(newKey) === null) storage.setItem(newKey, value);
    storage.removeItem(oldKey);
  }
}

/** Moves every old key to its new name. Never throws (storage may be unavailable). */
export function migrateLegacyStorage(local?: Storage, session?: Storage) {
  try {
    move(local ?? window.localStorage, LEGACY_STORAGE_KEYS.local);
  } catch {
    // Storage blocked or unavailable: nothing to move.
  }
  try {
    move(session ?? window.sessionStorage, LEGACY_STORAGE_KEYS.session);
  } catch {
    // As above.
  }
}

migrateLegacyStorage();
